// extracted by mini-css-extract-plugin
export default {"iframe":"TrailerVideo_iframe__oY+Hb","videoBox":"TrailerVideo_videoBox__NuTNr"};